import { observer } from 'mobx-react';
import {
  Button,
  createDateField,
  createTextField,
  StandardDialog,
} from '@roc/ui';
import { Box, Grid } from '@material-ui/core';
import { useDrawsStore } from '../hooks';
import { FormStore } from '@roc/feature-app-core';
import { useEffect } from 'react';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface InspectionInvoiceDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const InspectionInvoiceDetailsDialog = observer(({ open, onClose, document }: InspectionInvoiceDetailsDialogProps) => {

  const { drawStore } = useDrawsStore();
  const inspectionInvoiceDetailsFormStore = drawStore.inspectionInvoiceDetailsFormStore;
  const formDisabled = !inspectionInvoiceDetailsFormStore.form.fields.inspectionCompany.value;
  const taskId = document?.taskId;

  useEffect(() => {
    if (open) {
      inspectionInvoiceDetailsFormStore.loadInspectionInvoiceDetails(document?.drawId);
    }
  }, [inspectionInvoiceDetailsFormStore, document, open]);

  const onSubmit = async () => {
    const result = await inspectionInvoiceDetailsFormStore.updateInspectionInvoice(document?.drawId);
    if (result) {
      onClose();
    }
  }

  const dialogContent = (
    < Box display="flex" flexDirection="column" gridGap="1rem">
      <InspectionInvoiceDetailsForm store={inspectionInvoiceDetailsFormStore} disabled={formDisabled} />
      <Box display="flex" justifyContent="flex-end" alignItems="center" gridGap="1rem">
        <Button
          testId="cancel"
          variant="outlined"
          color="primary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          testId="submit"
          variant="outlined"
          color="primary"
          onClick={onSubmit}
          disabled={formDisabled}
        >
          Submit
        </Button>
      </Box>
    </Box>);

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Inspection Invoice Details"
          handleClose={onClose}
          dialogContent={dialogContent}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Inspection Invoice Details"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={dialogContent}
        />
      )}
    </>
  )
});

interface InspectionInvoiceDetailsFormProps {
  store: FormStore;
  disabled?: boolean;
}


const InspectionInvoiceDetailsForm = observer(({ store, disabled = false }: InspectionInvoiceDetailsFormProps) => {


  return (
    <Box display="flex" flexDirection="column" gridGap="1rem">
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Inspection Company',
            fieldName: 'inspectionCompany',
            testId: 'inspectionCompany',
            store,
            standaloneLabel: false,
            disabled: true
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Invoice #',
            fieldName: 'invoiceNumber',
            testId: 'invoiceNumber',
            store,
            standaloneLabel: false,
            disabled: disabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createDateField({
            label: 'Invoice Date',
            fieldName: 'invoiceDate',
            testId: 'invoiceDate',
            store,
            standaloneLabel: false,
            disabled: disabled,
            disableFuture: true
          })}
        </Grid>
      </Grid>
    </Box>);
})
